export default "__VITE_ASSET__e807864c__"